import React from 'react';
import Modal from "react-modal";
import Stripe from '../Stripe';
import * as actionTypes from "../../redux/actionTypes";
import { useSelector, useDispatch } from "react-redux";
import GamePass from '../GamePass';
import { safeLocalStorage } from '@utils/localstorage';

const BuyNft = ({ buyNft }) => {
    const dispatch = useDispatch()
    const strpiePayment = useSelector((state) => state.strpie.strpiePayment);

    const payNowClose = () => {
        dispatch({
            type: actionTypes.STRPIE_PAYMNET,
            payload: false
        })
        safeLocalStorage.removeItem('drivingBot')
        safeLocalStorage.removeItem('nftMinting')
    }

    return (
        <>
            <GamePass buyNft={buyNft} />
            <Modal
                isOpen={strpiePayment}
                ariaHideApp={false}
                className="mymodal"
                onRequestClose={payNowClose}
            >
                <Stripe payNowClose={payNowClose} />
            </Modal>
        </>
    )
}

export default BuyNft;